import { CONTACT_US } from "arv-extends/constants";

CONTACT_US.message1.info = "+91 7676866666";
CONTACT_US.message1.detail = "Monday - Sunday (9am - 9pm)";
CONTACT_US.message2.info = "thecircle@wildcraft.com";

export default CONTACT_US;
